import * as Toast from "@radix-ui/react-toast";

import styles from "./Messages.module.css";

/**
 * Container for messages to be displayed to the user
 */
const Messages = () => {
  return <Toast.Viewport className={styles.messages} />;
};

export default Messages;
